export const domElementIntoView = (selector: string) => {
  try {
    const el = document.querySelector(selector);
    el && el.scrollIntoView(true);
  } catch (error) {}
};
